// Mobile Grid Button Alignment - v3
(function() {
  function alignButtons() {
    if (window.innerWidth > 600) return;

    // Target mobile 2-column grid specifically
    const grid = document.querySelector('.page-grid-sp-2, .product-grid');
    if (!grid) return;

    const cards = grid.querySelectorAll('.product-card');
    if (cards.length < 2) return;

    // Reset all heights first
    cards.forEach(card => {
      const content = card.querySelector('.product-card__content');
      if (content) {
        content.style.minHeight = '';
        content.style.display = 'flex';
        content.style.flexDirection = 'column';
      }
    });

    // Wait for layout
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const cardsArray = Array.from(cards);

        // Process in pairs for 2-column layout
        for (let i = 0; i < cardsArray.length; i += 2) {
          const card1 = cardsArray[i];
          const card2 = cardsArray[i + 1];
          if (!card2) break;

          const content1 = card1.querySelector('.product-card__content');
          const content2 = card2.querySelector('.product-card__content');

          if (content1 && content2) {
            // Get actual heights
            const h1 = content1.offsetHeight;
            const h2 = content2.offsetHeight;
            const maxH = Math.max(h1, h2);

            if (maxH > 0) {
              content1.style.minHeight = maxH + 'px';
              content2.style.minHeight = maxH + 'px';
            }
          }

          // Force buttons to bottom
          [card1, card2].forEach(card => {
            const iface = card.querySelector('.product-card__interface');
            if (iface) {
              iface.style.marginTop = 'auto';
            }
            // Also try form element
            const form = card.querySelector('.product-card__content form');
            if (form) {
              form.style.marginTop = 'auto';
            }
          });
        }
      });
    });
  }

  // Run multiple times
  function runAlign() {
    alignButtons();
    setTimeout(alignButtons, 100);
    setTimeout(alignButtons, 250);
    setTimeout(alignButtons, 500);
    setTimeout(alignButtons, 1000);
    setTimeout(alignButtons, 2000);
  }

  // Hook into all load events
  document.addEventListener('DOMContentLoaded', runAlign);
  window.addEventListener('load', runAlign);

  // Also run immediately if already loaded
  if (document.readyState !== 'loading') {
    runAlign();
  }

  // Watch for grid class changes (view switcher)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(m => {
      if (m.type === 'attributes' && m.attributeName === 'class') {
        setTimeout(runAlign, 50);
      }
      if (m.type === 'childList') {
        setTimeout(alignButtons, 100);
      }
    });
  });

  setTimeout(() => {
    const grid = document.querySelector('.product-grid, [class*="page-grid"]');
    if (grid) {
      observer.observe(grid, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  }, 100);

  // Resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(runAlign, 150);
  });
})();
